"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.discovery = exports.getXpubOrDescriptorInfo = exports.deriveAddresses = exports.composeTx = exports.networks = exports.script = exports.payments = exports.crypto = exports.bufferutils = exports.bip32 = exports.address = exports.Transaction = void 0;
const address = require("./address");
exports.address = address;
const bip32 = require("./bip32");
exports.bip32 = bip32;
const bufferutils = require("./bufferutils");
exports.bufferutils = bufferutils;
const crypto = require("./crypto");
exports.crypto = crypto;
const payments = require("./payments");
exports.payments = payments;
const script = require("./script");
exports.script = script;
const networks = require("./networks");
exports.networks = networks;
const compose_1 = require("./compose");
Object.defineProperty(exports, "composeTx", { enumerable: true, get: function () { return compose_1.composeTx; } });
const derivation_1 = require("./derivation");
Object.defineProperty(exports, "deriveAddresses", { enumerable: true, get: function () { return derivation_1.deriveAddresses; } });
Object.defineProperty(exports, "getXpubOrDescriptorInfo", { enumerable: true, get: function () { return derivation_1.getXpubOrDescriptorInfo; } });
const discovery_1 = require("./discovery");
Object.defineProperty(exports, "discovery", { enumerable: true, get: function () { return discovery_1.discovery; } });
var transaction_1 = require("./transaction");
Object.defineProperty(exports, "Transaction", { enumerable: true, get: function () { return transaction_1.Transaction; } });
